import { Component, inject, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GroupSeriesInfoDto } from '../../dtos/groupseriesinfo.dto';
import { TextButton } from '../../../../shared/components/text-button/text-button.component';
import { TranslocoPipe } from '@jsverse/transloco';
import { MatIconModule } from '@angular/material/icon';
import { MemoryService } from '../../../../core/services/memory.service';
import { Router } from '@angular/router';
import {CourseService} from '../../course.service';
import {GroupSeriesParameterDto} from '../../dtos/groupseriesparameter.dto';

@Component({
  selector: 'app-course-info',
  imports: [TextButton, TranslocoPipe, MatIconModule],
  templateUrl: './course-info.dialog.html',
  styleUrl: './course-info.dialog.scss'
})
export class CourseInfoDialog implements OnInit {
  memoryService = inject(MemoryService);
  dialogRef = inject(MatDialogRef<CourseInfoDialog>);
  courseService = inject(CourseService);
  router: Router = inject(Router);
  course!: GroupSeriesInfoDto;

  constructor(@Inject(MAT_DIALOG_DATA) public data: { course: GroupSeriesInfoDto }) {
  }

  ngOnInit() {
    this.course = this.data.course;
    // load data in case it's not contained.
    if(!this.course.title && this.course!.id! > 0){
      const payload: GroupSeriesParameterDto = {
        locationId: this.memoryService.locationId,
        customerId: this.memoryService.customerId,
        patientId: this.memoryService.patientId,
        groupId: this.course.id!
      };
      this.courseService.loadCourseInfo(payload).subscribe({
        next: (dto: GroupSeriesInfoDto) => {
          this.course = dto;
        }
      });
    }
  }

  locationInfo() {
    return this.memoryService.locationDetailDto?.name + ', ' + this.memoryService.locationDetailDto?.contact?.street + ', ' + this.memoryService.locationDetailDto?.contact?.city;
  }

  getDescription(){
    if(this.course.descriptionRich && this.course.descriptionRich.length > 0){
      return this.course.descriptionRich;
    }

    return this.course.description;
  }

  showBooking() {
    this.dialogRef.close();
    this.router.navigate(['/course-booking', this.course.id]);
  }
}
